export default __webpack_public_path__ + "static/media/logo-insta-boost.pro.b2c60e5e.png";